'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _FormField = require('./FormField');

var _FormField2 = _interopRequireDefault(_FormField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxField = function (_Component) {
  _inherits(CheckboxField, _Component);

  function CheckboxField() {
    _classCallCheck(this, CheckboxField);

    var _this = _possibleConstructorReturn(this, (CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(CheckboxField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var fieldAttrs = {
        description: this.props.description,
        error: this.state.error,
        hint: this.props.hint,
        descriptionClass: this.props.descriptionClass,
        errorClass: this.props.errorClass,
        hintClass: this.props.hintClass
      };

      var inputAttrs = {
        autoFocus: this.props.autofocus,
        checked: this.props.checked,
        name: this.props.name,
        required: this.props.required,
        type: 'checkbox',
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        className: this.props.controlClass
      };

      var className = (0, _classnames3.default)(_defineProperty({
        CheckboxField: true
      }, this.props.className, !!this.props.className));

      return _react2.default.createElement(
        _FormField2.default,
        _extends({ className: className }, fieldAttrs),
        _react2.default.createElement(
          'label',
          { className: this.props.labelClass },
          _react2.default.createElement('input', _extends({ ref: function ref(el) {
              return _this2.input = el;
            } }, inputAttrs, { onChange: this.handleChange.bind(this), onInvalid: this.checkError.bind(this) })),
          this.props.label
        )
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autofocus) {
        this.input.focus();
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
      this.checkError(e);
    }
  }, {
    key: 'checkError',
    value: function checkError(e) {
      var el = this.input;
      var validity = el.validity;

      this.setState({
        error: this.props.validationMessage(validity, el)
      });
    }
  }]);

  return CheckboxField;
}(_react.Component);

CheckboxField.defaultProps = {
  validationMessage: function validationMessage(validity, el) {
    return el.validationMessage;
  }
};
exports.default = CheckboxField;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-forms/lib/CheckboxField.js
// module id = 1106
// module chunks = 0